module.exports = __webpack_public_path__ + "img/186.4b9b7d4c.jpg";